import React from "react";
import { Link } from "react-router-dom";

export default function MentionsLegales() {
  return (
    <div className="cs-cream py-16 min-h-[80vh]" data-testid="page-mentions-legales">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <div className="cs-eyebrow text-neutral-500">Informations légales</div>
        <h1 className="cs-h1 mt-3 text-4xl lg:text-5xl">Mentions légales</h1>

        <section className="mt-10 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Éditeur du site</h2>
          <p>
            Charbonier Studio<br />
            Entreprise individuelle<br />
            702 Chemin d'en Vindé<br />
            32130 Labastide-Savès — France<br />
            Email : <a href="mailto:contact@charbonierstudio.fr" className="cs-link-underline">contact@charbonierstudio.fr</a>
          </p>
          <p>
            SIREN : 947 450 953<br />
            SIRET : 94745095300015<br />
            TVA non applicable, article 293 B du Code général des impôts (franchise en base de TVA).
          </p>
          <p>
            Directeur de la publication : Damien Charbonier.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Hébergement</h2>
          <p>
            Le site charbonierstudio.fr est hébergé sur une infrastructure cloud fournie par
            Emergent (emergent.sh). Les données de commandes et les fichiers clients sont stockés dans une base de
            données MongoDB et un système d'objets sécurisé fournis par cet hébergeur.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Propriété intellectuelle</h2>
          <p>
            L'ensemble des contenus présents sur ce site (textes, mises en page, illustrations, logo, marques)
            est la propriété exclusive de Charbonier Studio ou de leurs ayants droit. Toute reproduction,
            représentation ou exploitation, en tout ou partie, sans autorisation écrite préalable est interdite.
          </p>
          <p>
            Les créations graphiques réalisées pour un client font l'objet d'une cession d'usage définie
            dans les <Link to="/cgv" className="cs-link-underline">conditions générales de vente</Link>.
          </p>
        </section>

        <section className="mt-8 space-y-4 text-[15px] leading-relaxed text-neutral-800">
          <h2 className="cs-h3 text-2xl">Contact</h2>
          <p>
            Pour toute question, contactez le studio à l'adresse
            <a href="mailto:contact@charbonierstudio.fr" className="cs-link-underline"> contact@charbonierstudio.fr</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
